export default {
  events: [],
  evaluations: [],
  bestellungen: []
}
